module.exports = __webpack_public_path__ + "img/country-usa.34001828.png";